import { ChangeDetectorRef, Injectable } from '@angular/core';

export interface ToastInfo {
  header?: string;
  body: string;
  classname?: string;
  delay?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: ToastInfo[] = [];
  private cdr?: ChangeDetectorRef;

  registerChangeDetector(cdr: ChangeDetectorRef) {
    this.cdr = cdr;
  }

  triggerChange() {
    if (this.cdr) {
      this.cdr.markForCheck();
    }
  }

  private show(body: string, options: Partial<ToastInfo> = {}) {
    const toast: ToastInfo = { body, ...options };
    this.toasts.push(toast);
    this.triggerChange();
    const delay = options.delay ?? 10000; // Default delay of 10 seconds
    if (delay > 0) {
      setTimeout(() => this.remove(toast), delay);
    }
  }

  success(body: string, header?: string, delay?: number) {
    this.show(body, {
      header: header ?? 'Success',
      classname: 'bg-success text-white',
      delay,
    });
  }

  error(body: string, header?: string, delay?: number) {
    this.show(body, {
      header: header ?? 'Error',
      classname: 'bg-danger text-white',
      delay,
    });
  }

  info(body: string, header?: string, delay?: number) {
    this.show(body, {
      header: header ?? 'Info',
      classname: 'bg-info text-white',
      delay,
    });
  }

  warning(body: string, header?: string, delay?: number) {
    this.show(body, {
      header: header ?? 'Warning',
      classname: 'bg-warning text-dark',
      delay,
    });
  }

  remove(toast: ToastInfo) {
    this.toasts = this.toasts.filter(t => t !== toast);
    this.triggerChange();
  }

  clear() {
    this.toasts = [];
    this.triggerChange();
  }
}
